import React from "react";
import { MyPetsScreen } from "~/features/my-pets/MyPetsScreen";

const Component = () => {
  return <MyPetsScreen />;
};

export default Component;
